// Guest-facing translations for English, Spanish, French, and German

export const translations = {
  en: {
    // Landing Page
    landing: {
      title: "La Olla",
      slogan: "Where the day's adventures become tonight's stories.",
      welcome: "Welcome to La Olla",
      description: "Your family-style dining experience in the heart of Costa Rica. Fresh, local ingredients prepared with love.",
      mealTimes: "Meal Times & Prices",
      breakfast: "Breakfast",
      lunch: "Lunch", 
      dinner: "Dinner",
      guestArrival: "Guests may arrive anytime within the meal window.",
      makeReservation: "Make a Reservation",
      scanQR: "Scan your cabin's QR code to make a reservation",
      kitchenPortal: "Kitchen Portal",
      adminPortal: "Admin Portal"
    },
    
    // Guest Reservation Page
    reservation: {
      backToHome: "Back to Home",
      reservationFor: "Reservations for",
      guestInfo: "Guest Information",
      guestInfoDesc: "Please provide your details for the reservation",
      guestName: "Guest Name",
      guestNamePlaceholder: "Enter your name",
      arrivalDate: "Arrival Date",
      departureDate: "Departure Date",
      selectDate: "Select date",
      numberOfGuests: "Number of Guests",
      guestsInCabin: "guests in your cabin",
      dietaryRequirements: "Dietary Requirements",
      dietaryDescription: "Enter the number of guests for each dietary requirement",
      vegetarian: "Vegetarian",
      vegan: "Vegan",
      glutenFree: "Gluten-Free",
      updateInfo: "Update Information",
      register: "Register",
      
      // Make Reservation Section
      makeReservation: "Make a Reservation",
      mealTimesAndPrices: "Meal Times & Prices",
      guestsMayArrive: "Guests may arrive anytime within the meal window.",
      reservationTimeNote: "Reservations must be made at least 2 hours before meal time",
      breakfastDesc: "Breakfast has a menu to order from.",
      lunchDinnerDesc: "Lunch & Dinner are preplanned meals for all the family cabins.",
      accommodateDesc: "If you have a diet, allergy or special request we will be happy to accommodate.",
      selectMeals: "Select Meals",
      roomService: "Room Service",
      roomServiceDesc: "Delivery to your cabin",
      perPerson: "/person",
      specialTimeRequest: "Special Time Request (Optional)",
      specialTimePlaceholder: "e.g., 'We need to eat early at 6pm for the kids'",
      specialTimeNote: "Need a different time? Let us know and we'll do our best to accommodate.",
      specialRequests: "Special Requests (Optional)",
      specialRequestsPlaceholder: "Any allergies, dietary needs, or special requests...",
      submitReservation: "Submit Reservation",
      submitting: "Submitting...",
      reservingFor: "Reserving for",
      totalFor: "Total for",
      guests: "guest(s)",
      
      // Your Reservations Section
      yourReservations: "Your Reservations",
      reservationsDuring: "reservation(s) during your stay",
      noReservations: "No reservations yet",
      noReservationsDesc: "Select a date and meals above to make a reservation",
      cancelReservation: "Cancel Reservation",
      
      // Policies
      policyReservations: "Reservations and cancellations must be made at least",
      policyHours: "2 hours",
      policyBefore: "before meal time.",
      policyRoomService: "Room service available for",
      policyPayment: "Tab is paid in the restaurant on the last night before departure.",
      policyAccept: "We accept",
      policyMethods: "cash (USD or Colones), PayPal & Credit Card",
      
      // Update info
      updateIfNeeded: "Update your information if needed",
      registerToMake: "Please register to make reservations"
    },
    
    // Common
    common: {
      loading: "Loading...",
      error: "Error",
      success: "Success",
      cancel: "Cancel",
      ok: "Ok",
      close: "Close"
    },
    
    // Tabs
    tabs: {
      guestInfo: "Guest Info",
      tours: "Tours",
      restaurant: "Restaurant",
      payment: "Payment",
      myTours: "My Tours",
      availableTours: "Available Tours",
      myReservations: "My Reservations",
      makeReservation: "Make Reservation"
    }
  },
  
  es: {
    // Landing Page
    landing: {
      title: "La Olla",
      slogan: "Donde las aventuras del día se convierten en las historias de la noche.",
      welcome: "Bienvenidos a La Olla",
      description: "Tu experiencia gastronómica familiar en el corazón de Costa Rica. Ingredientes frescos y locales preparados con amor.",
      mealTimes: "Horarios y Precios",
      breakfast: "Desayuno",
      lunch: "Almuerzo",
      dinner: "Cena",
      guestArrival: "Los huéspedes pueden llegar en cualquier momento dentro del horario de la comida.",
      makeReservation: "Hacer una Reservación",
      scanQR: "Escanea el código QR de tu cabaña para hacer una reservación",
      kitchenPortal: "Portal de Cocina",
      adminPortal: "Portal de Administración"
    },
    
    // Guest Reservation Page
    reservation: {
      backToHome: "Volver al Inicio",
      reservationFor: "Reservaciones para",
      guestInfo: "Información del Huésped",
      guestInfoDesc: "Por favor proporcione sus datos para la reservación",
      guestName: "Nombre del Huésped",
      guestNamePlaceholder: "Ingrese su nombre",
      arrivalDate: "Fecha de Llegada",
      departureDate: "Fecha de Salida",
      selectDate: "Seleccionar fecha",
      numberOfGuests: "Número de Huéspedes",
      guestsInCabin: "huéspedes en su cabaña",
      dietaryRequirements: "Requisitos Dietéticos",
      dietaryDescription: "Ingrese el número de huéspedes para cada requisito dietético",
      vegetarian: "Vegetariano",
      vegan: "Vegano",
      glutenFree: "Sin Gluten",
      updateInfo: "Actualizar Información",
      register: "Registrar",
      
      // Make Reservation Section
      makeReservation: "Hacer una Reservación",
      mealTimesAndPrices: "Horarios y Precios",
      guestsMayArrive: "Los huéspedes pueden llegar en cualquier momento dentro del horario de la comida.",
      reservationTimeNote: "Las reservaciones deben hacerse al menos 2 horas antes del horario de la comida",
      breakfastDesc: "El desayuno tiene un menú para ordenar.",
      lunchDinnerDesc: "El almuerzo y la cena son comidas planificadas para todas las cabañas familiares.",
      accommodateDesc: "Si tiene una dieta, alergia o solicitud especial, estaremos encantados de acomodarle.",
      selectMeals: "Seleccionar Comidas",
      roomService: "Servicio a Habitación",
      roomServiceDesc: "Entrega a su cabaña",
      perPerson: "/persona",
      specialTimeRequest: "Solicitud de Horario Especial (Opcional)",
      specialTimePlaceholder: "ej., 'Necesitamos comer temprano a las 6pm para los niños'",
      specialTimeNote: "¿Necesita un horario diferente? Avísenos y haremos lo posible por acomodarle.",
      specialRequests: "Solicitudes Especiales (Opcional)",
      specialRequestsPlaceholder: "Cualquier alergia, necesidad dietética o solicitud especial...",
      submitReservation: "Enviar Reservación",
      submitting: "Enviando...",
      reservingFor: "Reservando para",
      totalFor: "Total para",
      guests: "huésped(es)",
      
      // Your Reservations Section
      yourReservations: "Sus Reservaciones",
      reservationsDuring: "reservación(es) durante su estadía",
      noReservations: "Sin reservaciones aún",
      noReservationsDesc: "Seleccione una fecha y comidas arriba para hacer una reservación",
      cancelReservation: "Cancelar Reservación",
      
      // Policies
      policyReservations: "Las reservaciones y cancelaciones deben hacerse al menos",
      policyHours: "2 horas",
      policyBefore: "antes del horario de la comida.",
      policyRoomService: "Servicio a habitación disponible por",
      policyPayment: "La cuenta se paga en el restaurante la última noche antes de la salida.",
      policyAccept: "Aceptamos",
      policyMethods: "efectivo (USD o Colones), PayPal y tarjeta de crédito",
      
      // Update info
      updateIfNeeded: "Actualice su información si es necesario",
      registerToMake: "Por favor regístrese para hacer reservaciones"
    },
    
    // Common
    common: {
      loading: "Cargando...",
      error: "Error",
      success: "Éxito",
      cancel: "Cancelar",
      ok: "Ok",
      close: "Cerrar"
    },
    
    // Tabs
    tabs: {
      guestInfo: "Info Huésped",
      tours: "Tours",
      restaurant: "Restaurante",
      payment: "Pago",
      myTours: "Mis Tours",
      availableTours: "Tours Disponibles",
      myReservations: "Mis Reservaciones",
      makeReservation: "Hacer Reservación"
    }
  },

  fr: {
    // Landing Page
    landing: {
      title: "La Olla",
      slogan: "Où les aventures du jour deviennent les histoires de la nuit.",
      welcome: "Bienvenue à La Olla",
      description: "Votre expérience culinaire familiale au cœur du Costa Rica. Ingrédients frais et locaux préparés avec amour.",
      mealTimes: "Horaires et Prix",
      breakfast: "Petit-déjeuner",
      lunch: "Déjeuner",
      dinner: "Dîner",
      guestArrival: "Les clients peuvent arriver à tout moment pendant le créneau horaire du repas.",
      makeReservation: "Faire une Réservation",
      scanQR: "Scannez le code QR de votre cabane pour faire une réservation",
      kitchenPortal: "Portail Cuisine",
      adminPortal: "Portail Admin"
    },
    
    // Guest Reservation Page
    reservation: {
      backToHome: "Retour à l'Accueil",
      reservationFor: "Réservations pour",
      guestInfo: "Informations Client",
      guestInfoDesc: "Veuillez fournir vos coordonnées pour la réservation",
      guestName: "Nom du Client",
      guestNamePlaceholder: "Entrez votre nom",
      arrivalDate: "Date d'Arrivée",
      departureDate: "Date de Départ",
      selectDate: "Sélectionner une date",
      numberOfGuests: "Nombre de Personnes",
      guestsInCabin: "personnes dans votre cabane",
      dietaryRequirements: "Exigences Alimentaires",
      dietaryDescription: "Entrez le nombre de personnes pour chaque exigence alimentaire",
      vegetarian: "Végétarien",
      vegan: "Végétalien",
      glutenFree: "Sans Gluten",
      updateInfo: "Mettre à Jour",
      register: "S'inscrire",
      
      // Make Reservation Section
      makeReservation: "Faire une Réservation",
      mealTimesAndPrices: "Horaires et Prix",
      guestsMayArrive: "Les clients peuvent arriver à tout moment pendant le créneau horaire du repas.",
      reservationTimeNote: "Les réservations doivent être faites au moins 2 heures avant le repas",
      breakfastDesc: "Le petit-déjeuner propose un menu à la carte.",
      lunchDinnerDesc: "Le déjeuner et le dîner sont des repas planifiés pour toutes les cabanes familiales.",
      accommodateDesc: "Si vous avez un régime, une allergie ou une demande spéciale, nous serons heureux de vous accommoder.",
      selectMeals: "Sélectionner les Repas",
      roomService: "Service en Chambre",
      roomServiceDesc: "Livraison à votre cabane",
      perPerson: "/personne",
      specialTimeRequest: "Demande d'Horaire Spécial (Optionnel)",
      specialTimePlaceholder: "ex., 'Nous devons manger tôt à 18h pour les enfants'",
      specialTimeNote: "Besoin d'un horaire différent? Faites-le nous savoir et nous ferons de notre mieux.",
      specialRequests: "Demandes Spéciales (Optionnel)",
      specialRequestsPlaceholder: "Allergies, besoins alimentaires ou demandes spéciales...",
      submitReservation: "Envoyer la Réservation",
      submitting: "Envoi en cours...",
      reservingFor: "Réservation pour",
      totalFor: "Total pour",
      guests: "personne(s)",
      
      // Your Reservations Section
      yourReservations: "Vos Réservations",
      reservationsDuring: "réservation(s) pendant votre séjour",
      noReservations: "Pas encore de réservations",
      noReservationsDesc: "Sélectionnez une date et des repas ci-dessus pour faire une réservation",
      cancelReservation: "Annuler la Réservation",
      
      // Policies
      policyReservations: "Les réservations et annulations doivent être faites au moins",
      policyHours: "2 heures",
      policyBefore: "avant l'heure du repas.",
      policyRoomService: "Service en chambre disponible pour",
      policyPayment: "L'addition est payée au restaurant la dernière nuit avant le départ.",
      policyAccept: "Nous acceptons",
      policyMethods: "espèces (USD ou Colones), PayPal et carte de crédit",
      
      // Update info
      updateIfNeeded: "Mettez à jour vos informations si nécessaire",
      registerToMake: "Veuillez vous inscrire pour faire des réservations"
    },
    
    // Common
    common: {
      loading: "Chargement...",
      error: "Erreur",
      success: "Succès",
      cancel: "Annuler",
      ok: "Ok",
      close: "Fermer"
    },
    
    // Tabs
    tabs: {
      guestInfo: "Info Client",
      tours: "Tours",
      restaurant: "Restaurant",
      payment: "Paiement",
      myTours: "Mes Tours",
      availableTours: "Tours Disponibles",
      myReservations: "Mes Réservations",
      makeReservation: "Faire une Réservation"
    }
  },

  de: {
    // Landing Page
    landing: {
      title: "La Olla",
      slogan: "Wo die Abenteuer des Tages zu den Geschichten der Nacht werden.",
      welcome: "Willkommen bei La Olla",
      description: "Ihr familienfreundliches Esserlebnis im Herzen Costa Ricas. Frische, lokale Zutaten mit Liebe zubereitet.",
      mealTimes: "Essenszeiten & Preise",
      breakfast: "Frühstück",
      lunch: "Mittagessen",
      dinner: "Abendessen",
      guestArrival: "Gäste können jederzeit innerhalb des Essenszeitfensters ankommen.",
      makeReservation: "Reservierung Machen",
      scanQR: "Scannen Sie den QR-Code Ihrer Hütte, um eine Reservierung zu machen",
      kitchenPortal: "Küchenportal",
      adminPortal: "Admin-Portal"
    },
    
    // Guest Reservation Page
    reservation: {
      backToHome: "Zurück zur Startseite",
      reservationFor: "Reservierungen für",
      guestInfo: "Gastinformationen",
      guestInfoDesc: "Bitte geben Sie Ihre Daten für die Reservierung an",
      guestName: "Name des Gastes",
      guestNamePlaceholder: "Geben Sie Ihren Namen ein",
      arrivalDate: "Ankunftsdatum",
      departureDate: "Abreisedatum",
      selectDate: "Datum auswählen",
      numberOfGuests: "Anzahl der Gäste",
      guestsInCabin: "Gäste in Ihrer Hütte",
      dietaryRequirements: "Ernährungsanforderungen",
      dietaryDescription: "Geben Sie die Anzahl der Gäste für jede Ernährungsanforderung ein",
      vegetarian: "Vegetarisch",
      vegan: "Vegan",
      glutenFree: "Glutenfrei",
      updateInfo: "Informationen Aktualisieren",
      register: "Registrieren",
      
      // Make Reservation Section
      makeReservation: "Reservierung Machen",
      mealTimesAndPrices: "Essenszeiten & Preise",
      guestsMayArrive: "Gäste können jederzeit innerhalb des Essenszeitfensters ankommen.",
      reservationTimeNote: "Reservierungen müssen mindestens 2 Stunden vor der Essenszeit gemacht werden",
      breakfastDesc: "Das Frühstück bietet eine Speisekarte zur Bestellung.",
      lunchDinnerDesc: "Mittag- und Abendessen sind geplante Mahlzeiten für alle Familienhütten.",
      accommodateDesc: "Wenn Sie eine Diät, Allergie oder besondere Anfrage haben, werden wir Sie gerne unterbringen.",
      selectMeals: "Mahlzeiten Auswählen",
      roomService: "Zimmerservice",
      roomServiceDesc: "Lieferung zu Ihrer Hütte",
      perPerson: "/Person",
      specialTimeRequest: "Besondere Zeitanfrage (Optional)",
      specialTimePlaceholder: "z.B., 'Wir müssen früh um 18 Uhr für die Kinder essen'",
      specialTimeNote: "Brauchen Sie eine andere Zeit? Lassen Sie es uns wissen und wir werden unser Bestes tun.",
      specialRequests: "Besondere Wünsche (Optional)",
      specialRequestsPlaceholder: "Allergien, Ernährungsbedürfnisse oder besondere Wünsche...",
      submitReservation: "Reservierung Absenden",
      submitting: "Wird gesendet...",
      reservingFor: "Reservierung für",
      totalFor: "Gesamt für",
      guests: "Gast/Gäste",
      
      // Your Reservations Section
      yourReservations: "Ihre Reservierungen",
      reservationsDuring: "Reservierung(en) während Ihres Aufenthalts",
      noReservations: "Noch keine Reservierungen",
      noReservationsDesc: "Wählen Sie oben ein Datum und Mahlzeiten aus, um eine Reservierung zu machen",
      cancelReservation: "Reservierung Stornieren",
      
      // Policies
      policyReservations: "Reservierungen und Stornierungen müssen mindestens",
      policyHours: "2 Stunden",
      policyBefore: "vor der Essenszeit gemacht werden.",
      policyRoomService: "Zimmerservice verfügbar für",
      policyPayment: "Die Rechnung wird am letzten Abend vor der Abreise im Restaurant bezahlt.",
      policyAccept: "Wir akzeptieren",
      policyMethods: "Bargeld (USD oder Colones), PayPal und Kreditkarte",
      
      // Update info
      updateIfNeeded: "Aktualisieren Sie Ihre Informationen bei Bedarf",
      registerToMake: "Bitte registrieren Sie sich, um Reservierungen zu machen"
    },
    
    // Common
    common: {
      loading: "Laden...",
      error: "Fehler",
      success: "Erfolg",
      cancel: "Abbrechen",
      ok: "Ok",
      close: "Schließen"
    },
    
    // Tabs
    tabs: {
      guestInfo: "Gast Info",
      tours: "Touren",
      restaurant: "Restaurant",
      payment: "Zahlung",
      myTours: "Meine Touren",
      availableTours: "Verfügbare Touren",
      myReservations: "Meine Reservierungen",
      makeReservation: "Reservierung Machen"
    }
  }
};

export const getMealNameTranslation = (mealType, lang) => {
  const mealNames = {
    en: { breakfast: "Breakfast", lunch: "Lunch", dinner: "Dinner" },
    es: { breakfast: "Desayuno", lunch: "Almuerzo", dinner: "Cena" },
    fr: { breakfast: "Petit-déjeuner", lunch: "Déjeuner", dinner: "Dîner" },
    de: { breakfast: "Frühstück", lunch: "Mittagessen", dinner: "Abendessen" }
  };
  return mealNames[lang]?.[mealType] || mealType;
};

export const getDietaryTranslation = (dietary, lang) => {
  const dietaryNames = {
    en: { vegetarian: "Vegetarian", vegan: "Vegan", "gluten-free": "Gluten-Free" },
    es: { vegetarian: "Vegetariano", vegan: "Vegano", "gluten-free": "Sin Gluten" },
    fr: { vegetarian: "Végétarien", vegan: "Végétalien", "gluten-free": "Sans Gluten" },
    de: { vegetarian: "Vegetarisch", vegan: "Vegan", "gluten-free": "Glutenfrei" }
  };
  return dietaryNames[lang]?.[dietary] || dietary;
};

// Kitchen Portal translations (Spanish default)
export const kitchenTranslations = {
  es: {
    // Login page
    backToHome: "Volver al Inicio",
    kitchenPortal: "Portal de Cocina",
    loginDescription: "Inicie sesión para ver los pedidos",
    username: "Usuario",
    usernamePlaceholder: "Ingrese usuario",
    password: "Contraseña",
    passwordPlaceholder: "Ingrese contraseña",
    loginButton: "Iniciar Sesión",
    loggingIn: "Iniciando sesión...",
    loginError: "Error al iniciar sesión",
    loginSuccess: "Inicio de sesión exitoso",
    invalidCredentials: "Credenciales inválidas",
    enterCredentials: "Por favor ingrese usuario y contraseña",
    
    // Dashboard
    loadingKitchen: "Cargando panel de cocina...",
    kitchenPanel: "Panel de Cocina",
    today: "Hoy",
    refresh: "Actualizar",
    logout: "Salir",
    lastUpdate: "Última actualización",
    autoRefresh: "Se actualiza automáticamente cada 30 segundos",
    
    // Meal names
    breakfast: "Breakfast (Desayuno)",
    lunch: "Lunch (Almuerzo)",
    dinner: "Dinner (Cena)",
    
    // Status labels
    passed: "Completado",
    soon: "Pronto",
    upcoming: "Próximo",
    
    // Guest info
    totalGuests: "Total Huéspedes",
    roomService: "Servicio a Habitación",
    tapToView: "Toca para ver",
    noReservations: "Sin reservaciones",
    cabin: "Cabaña",
    requestedTime: "Hora Solicitada",
    note: "Nota",
    noRoomServiceOrders: "No hay pedidos de servicio a habitación",
    
    // Dietary
    vegetarian: "Vegetariano",
    vegan: "Vegano",
    glutenFree: "Sin Gluten"
  },
  en: {
    // Login page
    backToHome: "Back to Home",
    kitchenPortal: "Kitchen Portal",
    loginDescription: "Log in to view orders",
    username: "Username",
    usernamePlaceholder: "Enter username",
    password: "Password",
    passwordPlaceholder: "Enter password",
    loginButton: "Log In",
    loggingIn: "Logging in...",
    loginError: "Login error",
    loginSuccess: "Login successful",
    invalidCredentials: "Invalid credentials",
    enterCredentials: "Please enter username and password",
    
    // Dashboard
    loadingKitchen: "Loading kitchen panel...",
    kitchenPanel: "Kitchen Panel",
    today: "Today",
    refresh: "Refresh",
    logout: "Logout",
    lastUpdate: "Last update",
    autoRefresh: "Auto-refreshes every 30 seconds",
    
    // Meal names
    breakfast: "Breakfast",
    lunch: "Lunch",
    dinner: "Dinner",
    
    // Status labels
    passed: "Completed",
    soon: "Soon",
    upcoming: "Upcoming",
    
    // Guest info
    totalGuests: "Total Guests",
    roomService: "Room Service",
    tapToView: "Tap to view",
    noReservations: "No reservations",
    cabin: "Cabin",
    requestedTime: "Requested Time",
    note: "Note",
    noRoomServiceOrders: "No room service orders",
    
    // Dietary
    vegetarian: "Vegetarian",
    vegan: "Vegan",
    glutenFree: "Gluten-Free"
  }
};
